import React from 'react'
import Media from 'sb-media'

import Minimal from 'common/components/layout/Footer/Minimal/Minimal'
import Mobile from './Mobile/Mobile'
import ExceptMobile from './ExceptMobile/ExceptMobile'


const Footer = ({ isMinimal, ...props }) => {
  if (isMinimal) {
    return (
      <Minimal withCopyright />
    )
  }

  return (
    <Media mobile>
      {
        (isMobile) => React.createElement(isMobile ? Mobile : ExceptMobile, props)
      }
    </Media>
  )
}


export default Footer
